export default __webpack_public_path__ + "static/media/mmiti.ea4e9ec8.png";